<template>
  <div class="header-part">
    <el-row class="nav-bar">
      <div class="logo">
        <router-link :to=" '/home' ">
          <img src="../assets/img/login.png" alt="">
        </router-link>
      </div>
      <div class="nav-list">
        <router-link :to=" '/home' ">{{contents[10]}}</router-link>
        <router-link :to=" '/game' ">{{contents[11]}}</router-link>
        <router-link :to=" '/user/1-1' ">{{contents[12]}}</router-link>
        <router-link :to=" '/pay' ">{{contents[13]}}</router-link>
        <router-link :to=" '/custom_service' ">{{contents[14]}}</router-link>
      </div>
    </el-row>
  </div>
</template>

<script>
    import httpRequest from '../service/http_request';
    const icp = require('../lib/icp');

  const Utils = require('../lib/utils')
  export default {
    data () {
      return {
        activeIndex: '1',
        showLottery: false,
          contents: ''
      }
  },
  mounted(){
    $('.nav-list a').on('click',function(e){
      event.preventDefault();
      $(this).css({'background-color':'#d6003f','color':'#fff'}).siblings().css({'background-color':'#fff','color':'#333'});
    });
  },
  created(){
      this.getContent();
  },

  methods: {
      getContent() {
          var self = this;
          httpRequest.request(
              'post',
              icp.urls.page_getContents, {
                  params:{
                      page: 2
                  }
              }, function (res) {
                  self.contents = res;
              })
      }
  }
}
</script>
<style lang="less">
  .header-part{
    width: 100%;
    min-width: 1200px;
    border-bottom: 5px #d6003e solid;
    .nav-bar{
      height: 85px;
      width: 1200px;
      margin: 0 auto;
      .logo{
        display: inline-block;
        width: 250px;
        float: left;
        img{
          display: inline-block;
          width: 100%;
        }
      }
      .nav-list{
        display: inline-block;
        float: left;
        margin-left: 50px;
        a{
          display: inline-block;
          width: 100px;
          text-align: center;
          line-height: 85px;
          font-size: 18px;
          color: #333;
        }
        a:hover{
          background-color: #d6003f;
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header1.vue